import translate from '@translate';
import React, { FC } from 'react';
import BodyTopBlock from 'src/components/BodyTopBlock';
import { DeleteIcon } from 'src/components/SkladonIcon/SmallIcons';
import { OrderExpeditionPackageType } from 'src/types/orderExpeditionPackage';

export interface TopBlockPropsType {
    data: OrderExpeditionPackageType | null;
    idOrderExpeditionPackage: string | undefined;
    disableEdit: boolean;
    permissionDelete: boolean;
    handleSave: () => void;
    handleDelete: () => void;
}

const TopBlock: FC<TopBlockPropsType> = (props) => {
    return (
        <>
            <BodyTopBlock
                actions={[
                    {
                        icon: <DeleteIcon />,
                        onClick: () => {
                            props.handleDelete();
                        },
                        tooltip: translate('orderExpeditionPackageDetail.action.delete'),
                        hidden: !props.permissionDelete,
                        variant: 'outlined',
                    },
                    {
                        label: translate('orderExpeditionPackageDetail.action.save'),
                        onClick: props.handleSave,
                        hidden: props.disableEdit,
                    },
                ]}
            />
        </>
    );
};

export default TopBlock;
